/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_0_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a small workbook you understand: a spending sheet, an inventory list or a simple project tracker. Before opening it in another app, record the sheet names, one important total and one representative formula. A screenshot of a chart or formatted table also gives you something concrete to compare.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_0_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个你熟悉的小文件，例如支出表、库存清单或项目跟踪表。打开前，记录工作表名称、一个关键合计和一条有代表性的公式，也可以截取图表或格式化表格作为对照。`)
};

/**
* | output |
* | --- |
* | "Choose a small workbook you understand: a spending sheet, an inventory list or a simple project tracker. Before opening it in another app, record the sheet n..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_0_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_0_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_0_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_0_paragraphs_0 as "gc.search_guides.gridcraft_excel_compatibility.sections.0.paragraphs.0" }